import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const BatteryColoredIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props
  return (
    <SvgIcon viewBox="0 0 331.7 338.58" style={{ color, fontSize, ...style }} {...rest}>
      <g>
        <path
          style={{ fill: '#58707C' }}
          d="M316.93,162.53c0.04,12.29,0.45,24.59,0,36.86c-0.41,11.08-9.74,19.3-21.96,20.07
		c-2.32,0.15-2.85,0.75-2.93,3.01c-0.66,17.53-11.35,30.4-28.21,34.1c-2.88,0.63-5.83,0.76-8.79,0.76
		c-67.76,0-135.52-0.1-203.28,0.06c-19.69,0.04-33.18-12.73-36.25-27.91c-0.08-0.4-0.16-0.75-0.61-0.88c0-22.03,0-44.07,0-66.1
		c6.25-0.01,12.51-0.01,18.76-0.02c0.04,1.18,0.13,2.35,0.13,3.53c0.01,18.78,0.02,37.56-0.02,56.34c-0.01,2.41,0.39,4.71,1.48,6.82
		c3.11,6.06,8.09,9.07,14.96,9.06c68.83-0.02,137.66-0.01,206.49-0.02c0.69,0,1.38-0.05,2.06-0.1c7.48-0.54,13.61-6.65,14.13-14.13
		c0.12-1.66,0.18-3.34,0.11-5.01c-0.68-16.64,1.84-19.22,18.39-18.53c0.49,0.02,0.98,0,1.47,0c4.65-0.02,5.32-0.68,5.34-5.24
		c0.04-10.91,0.08-21.82,0.11-32.73C304.52,162.5,310.73,162.52,316.93,162.53z"
        />
        <path
          style={{ fill: '#627E8C' }}
          d="M33.66,162.49c-6.25,0.01-12.51,0.01-18.76,0.02c0-21.84,0-43.67,0-65.51c0.98-0.6,0.85-1.72,1.08-2.6
		C20,79.03,33.52,68.24,49.4,68.22c69.31-0.07,138.63-0.08,207.94,0c19.08,0.02,34.24,15.21,34.43,34.25
		c0.03,2.85,0.8,3.51,3.58,3.58c12.17,0.3,21.56,9.86,21.66,21.97c0.1,11.5-0.04,23-0.07,34.5c-6.21-0.02-12.41-0.03-18.62-0.05
		l-0.26,0.04c0-11.61-0.01-23.23-0.01-34.84c-0.11-0.25-0.22-0.5-0.34-0.76c-0.59-1.91-2.16-2.08-3.78-2.09
		c-4.03-0.03-8.07,0.06-12.09-0.06c-4.08-0.12-7.45-3.04-8.46-6.98c-0.57-2.23-0.37-4.49-0.42-6.75c-0.08-3.83,0.28-7.73-0.34-11.48
		c-1.27-7.67-8.1-12.51-16.94-12.51c-68.14-0.01-136.28,0-204.42,0c-0.59,0-1.18-0.02-1.77,0.01c-8.5,0.41-15.56,6.72-15.63,14.69
		c-0.16,20.25-0.01,40.5,0.02,60.76C33.89,162.53,33.66,162.49,33.66,162.49z"
        />
        <path
          style={{ fill: '#DADBDA' }}
          d="M298.31,162.49c-0.04,10.91-0.08,21.82-0.11,32.73c-0.01,4.56-0.68,5.22-5.34,5.24c-0.49,0-0.98,0.02-1.47,0
		c-16.55-0.7-19.07,1.89-18.39,18.53c0.07,1.67,0.01,3.34-0.11,5.01c-0.52,7.47-6.65,13.58-14.13,14.13
		c-0.69,0.05-1.37,0.1-2.06,0.1c-68.83,0-137.66,0-206.49,0.02c-6.87,0-11.84-3.01-14.96-9.06c-1.09-2.11-1.48-4.41-1.48-6.82
		c0.04-18.78,0.03-37.56,0.02-56.34c0-1.18-0.08-2.35-0.13-3.53c0,0,0.23,0.04,0.23,0.04c6.23-0.01,12.46-0.02,18.7-0.03
		c0.03,15.72,0.08,31.44,0.07,47.16c0,2.38,0.64,4.43,2.13,6.25c2.4,2.94,5.64,3.64,9.23,3.63c28.89-0.02,57.79-0.01,86.68-0.02
		c0.97,0,1.97,0.16,2.89-0.33c1.18,0.03,2.35,0.1,3.53,0.1c27.33,0.01,54.65,0,81.98,0c1.77,0,3.54,0.03,5.31-0.01
		c5.83-0.13,9.59-3.81,9.65-9.62c0.08-7.67,0-15.33,0.03-23c0.03-8.06,0.1-16.11,0.15-24.17c14.61,0.01,29.22,0.02,43.83,0.03
		L298.31,162.49z"
        />
        <path
          style={{ fill: '#EFF1F4' }}
          d="M298.06,162.53c-14.61-0.01-29.22-0.02-43.83-0.03c-0.05-1.08-0.14-2.15-0.14-3.23
		c-0.01-14.16,0.01-28.31-0.01-42.47c-0.01-7.18-3.7-10.82-10.95-10.82c-59.87-0.04-119.74-0.08-179.62-0.1
		c-1.15,0-2.37-0.32-3.43,0.46c-4.65,1.07-7.4,4.42-7.41,9.16c-0.05,15.66-0.06,31.33-0.09,46.99c-6.23,0.01-12.46,0.02-18.7,0.03
		c-0.03-20.25-0.19-40.51-0.02-60.76c0.06-7.97,7.13-14.28,15.63-14.69c0.59-0.03,1.18-0.01,1.77-0.01c68.14,0,136.28,0,204.42,0
		c8.83,0,15.67,4.84,16.94,12.51c0.62,3.74,0.26,7.65,0.34,11.48c0.05,2.25-0.15,4.52,0.42,6.75c1.01,3.94,4.38,6.86,8.46,6.98
		c4.03,0.12,8.06,0.03,12.09,0.06c1.62,0.01,3.19,0.18,3.78,2.09c0.11,0.25,0.22,0.5,0.34,0.76
		C298.05,139.3,298.05,150.92,298.06,162.53z"
        />
        <path
          style={{ fill: '#DADBDA' }}
          d="M298.05,127.69c-0.11-0.25-0.22-0.5-0.34-0.76C297.82,127.18,297.93,127.44,298.05,127.69z"
        />
        <path
          style={{ fill: '#439846' }}
          d="M52.58,162.5c0.03-15.66,0.05-31.33,0.09-46.99c0.01-4.74,2.76-8.1,7.41-9.16c1.18,0.03,2.35,0.1,3.53,0.1
		c28.88,0.01,57.76,0.03,86.64-0.04c2.44-0.01,3.4,0.42,3.39,3.18c-0.1,36.54-0.07,73.08-0.08,109.62
		c-0.92,0.49-1.92,0.33-2.89,0.33c-28.89,0.01-57.79,0-86.68,0.02c-3.58,0-6.83-0.69-9.23-3.63c-1.49-1.82-2.13-3.87-2.13-6.25
		C52.67,193.94,52.62,178.22,52.58,162.5z"
        />
        <path
          style={{ fill: '#54A853' }}
          d="M153.58,219.19c0-36.54-0.02-73.08,0.08-109.62c0.01-2.76-0.95-3.19-3.39-3.18
		c-28.88,0.08-57.76,0.05-86.64,0.04c-1.18,0-2.35-0.07-3.53-0.1c1.05-0.78,2.28-0.46,3.43-0.46c59.87,0.02,119.74,0.06,179.62,0.1
		c7.25,0.01,10.94,3.64,10.95,10.82c0.02,14.16,0,28.31,0.01,42.47c0,1.08,0.09,2.15,0.14,3.23c-0.05,8.06-0.12,16.11-0.15,24.17
		c-0.03,7.67,0.05,15.33-0.03,23c-0.06,5.82-3.82,9.5-9.65,9.62c-1.77,0.04-3.54,0.01-5.31,0.01c-27.33,0-54.65,0-81.98,0
		C155.93,219.29,154.76,219.23,153.58,219.19z"
        />
      </g>
    </SvgIcon>
  )
}
export default BatteryColoredIcon
